import { StepEditorProps } from "../useStepEditor";
import { StepEditorAccordion } from "../../../workflows/routes/WorkflowEditor/StepEditorAccordion";
import { Block } from "../../../../components/atoms";
import { prefixForm } from "../../../../utils/FormUtils";
import { useDataSources } from "../../../datasources/hooks/useDataSources";
import { useMemo } from "react";
import { Field, Select } from "@introist/react-foundation/v2";
import { TagAwareInput } from "modules/flows/components/TagAwareInput";

export const HibobUpdateEmailStepEditor = ({ form, stepDataPath, workflowId }: StepEditorProps) => {
  const prefixedForm = prefixForm(form, stepDataPath);

  const { dataSources } = useDataSources();

  const hibobSourceOptions = useMemo(() => {
    if (!dataSources) return [];
    return dataSources
      .filter(ds => ds.sourceType === "hibob")
      .map(s => ({ key: s.id, title: s.name }));
  }, [dataSources]);

  return (
    <>
      <Block blended compact>
        <StepEditorAccordion title="Target" defaultOpen>
          <StepEditorAccordion.Row label="Data source">
            <Select
              size="small"
              element="button"
              variant="blended"
              style={{ width: "100%" }}
              options={hibobSourceOptions}
              value={prefixedForm.get("datasourceId")}
              onSelect={opt => prefixedForm.set("datasourceId")(opt.key)}
              placeholder="Select HiBob integration"
              attachToRef={false}
            />
          </StepEditorAccordion.Row>
        </StepEditorAccordion>
      </Block>
      <Block blended compact>
        <StepEditorAccordion title="Email" defaultOpen>
          <Field title="New email address">
            <TagAwareInput
              value={prefixedForm.get("email")}
              onChange={prefixedForm.set("email")}
              error={prefixedForm.isError("email")}
              placeholder="Enter email or use tags"
              size="small"
              variant="blended"
              disabled={!prefixedForm.get("datasourceId")}
              tagSelectContext={{ workflowId }}
            />
          </Field>
        </StepEditorAccordion>
      </Block>
    </>
  );
};
